import { BaseResponseCode } from 'shared/entities/network';

import { TranslationString } from '../localization';

export enum ListEntityType {
  users = 'users'
}

export const listEntityTypesOrder = [ListEntityType.users];

export enum ListEntityTag {
  unsubscribed = 'unsubscribed'
}

export enum ListEntityErrorCode {
  listFillInProgress = 'list_fill_in_progress'
}

export type ListEntityServer = {
  _id: string;
  name: string;
  type: ListEntityType;
  tag: ListEntityTag;
  count: number;
};

export const mapListEntityErrorCodeToMessage = (
  code: string
): TranslationString => {
  if (code === ListEntityErrorCode.listFillInProgress) {
    return (t) =>
      t('lists.ListEntityModel.notifications.listFillInProgress', {
        ns: 'models'
      });
  }

  return () => '';
};

export const mapListsCreateErrorCodeToMessage =
  (code: BaseResponseCode.conflict): TranslationString =>
  (t) =>
    t(`usersList.errors.createLists.${code}`, {
      ns: 'entities'
    });
